import { Button, Stack } from '@mui/material'
import dayjs from 'dayjs'
import { useContext, useMemo, useState } from 'react'

import { AuthContext } from '../../providers'
import { useGetAppointmentsForCustomerQuery } from '../../redux/api'
import { CustomerEntry } from '../../sdk'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { localDateTimeArrayToDate } from '../../utils/localDateTimeArraytoDate/localDateTimeArrayToDate'
import { AppointmentPanel } from '../AppointmentPanel'
import CustomerChatPanelWrapper from '../ChatServices/CustomerChatPanelWrapper'

export const AppointmentByCustomer = ({
  customer
}: {
  customer: CustomerEntry
}) => {
  const { currentUser, userShopId } = useContext(AuthContext)
  const accessToken = loggingAssert(
    'No access token found where one was expected',
    currentUser?.accessToken
  )
  const shopId = loggingAssert(
    'No shop ID found where one was expected',
    userShopId
  )
  const { data: appointments } = useGetAppointmentsForCustomerQuery({
    authorization: accessToken,
    shop: shopId,
    customer: customer.id!
  })

  const recentAppointments = useMemo(() => {
    const aWeekAgo = dayjs(new Date()).subtract(7, 'day')
    return (appointments || []).filter(
      (appointment) =>
        dayjs(localDateTimeArrayToDate(appointment.info!.startDateTime)).diff(
          aWeekAgo
        ) > 0
    )
  }, [appointments])

  const [customerChatIsOpen, setCustomerChatIsOpen] = useState(false)

  return (
    <Stack spacing={2} aria-label="appointmentContainer">
      {recentAppointments.map((appointment, index) => (
        <AppointmentPanel appointment={appointment} key={index} />
      ))}
      {!customerChatIsOpen && (
        <Button
          variant="contained"
          onClick={() => setCustomerChatIsOpen(!customerChatIsOpen)}>
          Open Customer Chat
        </Button>
      )}
      <CustomerChatPanelWrapper
        customerChatIsOpen={customerChatIsOpen}
        setCustomerChatIsOpen={setCustomerChatIsOpen}
        customer={customer}
      />
    </Stack>
  )
}
